import confetti from "canvas-confetti";

const shapeCache = {};

const emojiShapes = (emojis, scalar) =>
  emojis.map((e) => {
    const key = `${e}-${scalar}`;
    if (!shapeCache[key]) {
      shapeCache[key] = confetti.shapeFromText({ text: e, scalar });
    }
    return shapeCache[key];
  });

export function fireHeartsConfetti() {
  const scalar = 2.4;
  const shapes = emojiShapes(["💘", "💖", "🏹", "❤️"], scalar);
  const defaults = {
    spread: 100,
    ticks: 180,
    gravity: 0.4,
    decay: 0.95,
    startVelocity: 26,
    shapes,
    scalar,
    zIndex: 9999,
  };
  confetti({ ...defaults, particleCount: 30, origin: { x: 0.5, y: 0.55 } });
  setTimeout(() => confetti({ ...defaults, particleCount: 20, origin: { x: 0.2, y: 0.65 } }), 200);
  setTimeout(() => confetti({ ...defaults, particleCount: 20, origin: { x: 0.8, y: 0.65 } }), 400);
}

export function fireDiamondsConfetti() {
  const scalar = 2.4;
  const shapes = emojiShapes(["💎", "✨", "🤍"], scalar);
  const defaults = {
    spread: 100,
    ticks: 180,
    gravity: 0.45,
    decay: 0.95,
    startVelocity: 28,
    shapes,
    scalar,
    zIndex: 9999,
  };
  confetti({ ...defaults, particleCount: 30, origin: { x: 0.5, y: 0.55 } });
  setTimeout(() => confetti({ ...defaults, particleCount: 20, origin: { x: 0.2, y: 0.65 } }), 200);
  setTimeout(() => confetti({ ...defaults, particleCount: 20, origin: { x: 0.8, y: 0.65 } }), 400);
}

export function fireBoostConfetti() {
  const scalar = 2.2;
  const shapes = emojiShapes(["🚀", "⚡", "✨"], scalar);
  const defaults = {
    spread: 90,
    ticks: 200,
    gravity: 0.6,
    decay: 0.94,
    startVelocity: 34,
    shapes,
    scalar,
    zIndex: 9999,
  };
  confetti({ ...defaults, particleCount: 35, origin: { x: 0.5, y: 0.5 } });
  setTimeout(() => confetti({ ...defaults, particleCount: 25, origin: { x: 0.25, y: 0.6 } }), 250);
  setTimeout(() => confetti({ ...defaults, particleCount: 25, origin: { x: 0.75, y: 0.6 } }), 500);
}

export function fireCoinsConfetti() {
  const scalar = 2.2;
  const shapes = emojiShapes(["🪙", "💰", "✨"], scalar);
  const defaults = {
    spread: 80,
    ticks: 200,
    gravity: 0.8,
    decay: 0.94,
    startVelocity: 34,
    shapes,
    scalar,
    zIndex: 9999,
  };
  confetti({ ...defaults, particleCount: 35, origin: { x: 0.5, y: 0.4 } });
  setTimeout(() => confetti({ ...defaults, particleCount: 25, origin: { x: 0.3, y: 0.5 } }), 250);
  setTimeout(() => confetti({ ...defaults, particleCount: 25, origin: { x: 0.7, y: 0.5 } }), 500);
}

export function fireTrophyConfetti() {
  const scalar = 2.4;
  const shapes = emojiShapes(["🏆", "🥇", "✨"], scalar);
  const defaults = {
    spread: 100,
    ticks: 190,
    gravity: 0.5,
    decay: 0.95,
    startVelocity: 30,
    shapes,
    scalar,
    zIndex: 9999,
  };
  confetti({ ...defaults, particleCount: 30, origin: { x: 0.5, y: 0.5 } });
  setTimeout(() => confetti({ ...defaults, particleCount: 20, origin: { x: 0.25, y: 0.6 } }), 200);
  setTimeout(() => confetti({ ...defaults, particleCount: 20, origin: { x: 0.75, y: 0.6 } }), 400);
}
